import { GraduationMonth } from './graduation-month.constant';

// TValidGradDates is mapped to the "GRAD_DATES" const on the backend
export type TValidGradDates =
  | 'Jan 2018'
  | 'March 2018'
  | 'June 2018'
  | 'Aug 2018'
  | 'Jan 2019'
  | 'March 2019'
  | 'June 2019'
  | 'Aug 2019'
  | 'Jan 2020'
  | 'March 2020'
  | 'June 2020'
  | 'Aug 2020'
  | 'Jan 2021'
  | 'March 2021'
  | 'June 2021'
  | 'Aug 2021'
  | 'Jan 2022'
  | 'March 2022'
  | 'June 2022'
  | 'Aug 2022'
  | 'Jan 2023'
  | 'March 2023'
  | 'June 2023'
  | 'Aug 2023'
  | 'Jan 2024'
  | 'March 2024'
  | 'June 2024'
  | 'Aug 2024'
  | '—';

export interface IGraduationDate {
  humanName: TValidGradDates;
  month: string;
  monthOrder: number;
  year: number;
}

// TODO UPDATE AT ATS FLIP: add new grad dates, remove old grad dates
export const GraduationDate = {
  JAN_2018: {
    humanName: 'Jan 2018',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2018,
  } as IGraduationDate,
  MARCH_2018: {
    humanName: 'March 2018',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2018,
  } as IGraduationDate,
  JUNE_2018: {
    humanName: 'June 2018',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2018,
  } as IGraduationDate,
  AUG_2018: {
    humanName: 'Aug 2018',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2018,
  } as IGraduationDate,
  JAN_2019: {
    humanName: 'Jan 2019',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2019,
  } as IGraduationDate,
  MARCH_2019: {
    humanName: 'March 2019',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2019,
  } as IGraduationDate,
  JUNE_2019: {
    humanName: 'June 2019',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2019,
  } as IGraduationDate,
  AUG_2019: {
    humanName: 'Aug 2019',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2019,
  } as IGraduationDate,
  JAN_2020: {
    humanName: 'Jan 2020',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2020,
  } as IGraduationDate,
  MARCH_2020: {
    humanName: 'March 2020',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2020,
  } as IGraduationDate,
  JUNE_2020: {
    humanName: 'June 2020',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2020,
  } as IGraduationDate,
  AUG_2020: {
    humanName: 'Aug 2020',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2020,
  } as IGraduationDate,
  JAN_2021: {
    humanName: 'Jan 2021',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2021,
  } as IGraduationDate,
  MARCH_2021: {
    humanName: 'March 2021',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2021,
  } as IGraduationDate,
  JUNE_2021: {
    humanName: 'June 2021',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2021,
  } as IGraduationDate,
  AUG_2021: {
    humanName: 'Aug 2021',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2021,
  } as IGraduationDate,
  JAN_2022: {
    humanName: 'Jan 2022',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2022,
  } as IGraduationDate,
  MARCH_2022: {
    humanName: 'March 2022',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2022,
  } as IGraduationDate,
  JUNE_2022: {
    humanName: 'June 2022',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2022,
  } as IGraduationDate,
  AUG_2022: {
    humanName: 'Aug 2022',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2022,
  } as IGraduationDate,
  JAN_2023: {
    humanName: 'Jan 2023',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2023,
  } as IGraduationDate,
  MARCH_2023: {
    humanName: 'March 2023',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2023,
  } as IGraduationDate,
  JUNE_2023: {
    humanName: 'June 2023',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2023,
  } as IGraduationDate,
  AUG_2023: {
    humanName: 'Aug 2023',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2023,
  } as IGraduationDate,
  JAN_2024: {
    humanName: 'Jan 2024',
    month: GraduationMonth.JAN,
    monthOrder: 1,
    year: 2024,
  } as IGraduationDate,
  MARCH_2024: {
    humanName: 'March 2024',
    month: GraduationMonth.MAR,
    monthOrder: 2,
    year: 2024,
  } as IGraduationDate,
  JUNE_2024: {
    humanName: 'June 2024',
    month: GraduationMonth.JUNE,
    monthOrder: 3,
    year: 2024,
  } as IGraduationDate,
  AUG_2024: {
    humanName: 'Aug 2024',
    month: GraduationMonth.AUG,
    monthOrder: 4,
    year: 2024,
  } as IGraduationDate,
};

// TODO UPDATE AT ATS FLIP: change to to GraduationDate.AUG_[current school year end]
// TODO UPDATE AT TERM 1 FLIP: change to to GraduationDate.JAN_[current school year end]
// TODO UPDATE AT TERM 2 FLIP: change to GraduationDate.MARCH_[current school year end]
// TODO UPDATE AT END OF MARCH: change to GraduationDate.JUNE_[current school year end]
export const NextGraduationDate = GraduationDate.JAN_2021 as IGraduationDate;
